export const keepFocus =
  (fn: (...args: any[]) => Promise<any>) =>
  (...args: any[]) => {
    const activeElement = document.activeElement;
    return fn(...args).finally(() => (activeElement as HTMLElement).focus());
  };
